import { MicrodataItem } from '@common/interface/meta-pixel'
import { IProductItem } from '@common/interface/product'
import { canBuy } from './can-buy'
import { Cart } from '@medusajs/medusa'

export const mapToMicrodataPixel = (
  cart: Cart,
  product?: IProductItem,
  brands?: any[]
): MicrodataItem[] => {
  const microdatas: MicrodataItem[] = []

  if (product != null) {
    for (let i = 0; i < product.variants.length; i++) {
      const variant = product.variants[i]

      microdatas.push({
        title: `${product.title}`,
        description: (product.description ?? '').replace(/(<([^>]+)>)/gi, ''),
        url:
          typeof window !== 'undefined'
            ? (window.location.href as string)
            : `https://habbit.sg/products/${product.handle as string}`,
        image: (variant as any)?.img ?? product.thumbnail ?? '',
        locale: cart.region.countries[0].iso_2,
        price: ((variant as any).calculated_price / 100).toFixed(2),
        currency: cart.region.currency_code,
        brand: brands != null ? brands[0]?.title ?? 'brand' : 'brand',
        availability: canBuy(variant) ? 'in stock' : 'out of stock',
        condition: 'new',
        sku: variant.sku
      })
    }
  }

  return microdatas
}
